import type { NavItem } from '@/lib/contentful/api/getWebsiteConfig';
import { COPY } from '@/lib/copy';

type CtaButton = { text: string; url: string; isNewTab: boolean } | null;

type Props = {
  open: boolean;
  navItems: NavItem[];
  ctaButton: CtaButton;
  isActive: (item: NavItem) => boolean;
  handleClick: (e: React.MouseEvent<HTMLAnchorElement>, item: NavItem) => void;
  onClose: () => void;
};

export default function MobileDrawer({
  open,
  navItems,
  ctaButton,
  isActive,
  handleClick,
  onClose,
}: Props) {
  return (
    <>
      {/* Backdrop */}
      <div
        aria-hidden="true"
        onClick={onClose}
        className={`tablet:hidden fixed inset-0 z-[88] bg-black/40 transition-opacity duration-300 ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
      />

      {/* Slide-in panel */}
      <nav
        id="nav-mobile"
        aria-label={COPY.nav.mobileMenuLabel}
        aria-hidden={!open}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        {...(!open ? ({ inert: true } as any) : {})}
        className={`tablet:hidden fixed top-0 right-0 h-full w-[min(320px,100vw)] z-[90] bg-bg-main flex flex-col justify-center gap-2 px-10 transition-transform duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        {navItems.map((item) => (
          <a
            key={item.id}
            href={item.href}
            onClick={(e) => {
              handleClick(e, item);
              onClose();
            }}
            aria-current={isActive(item) ? 'page' : undefined}
            className="font-sans text-[1.35rem] font-bold tracking-[0.04em] capitalize text-text no-underline py-3 border-b border-bg-alt transition-colors hover:text-primary last:border-0"
          >
            {item.label}
          </a>
        ))}
        {ctaButton && (
          <a
            href={ctaButton.url}
            {...(ctaButton.isNewTab && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
            onClick={onClose}
            className="font-sans text-[0.82rem] font-bold tracking-[0.12em] uppercase bg-primary text-white px-8 py-3.5 mt-6 text-center no-underline transition-colors hover:bg-[var(--color-primary-dark)]"
          >
            {ctaButton.text}
          </a>
        )}
      </nav>
    </>
  );
}
